import React, { useEffect, useState } from "react";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { t } from "i18next";
import { useNavigate, useParams } from "react-router-dom";
import moment from "moment";
import {
  Form,
  Button,
  Col,
  Row,
  Table,
  NumberInput,
  Result
} from "common/elements";
import { getOne, updateRecordById } from "services/payroll"
import { Util } from "common/util";

const UpdatePayroll = () => {
  const [formData, setFormData] = useState({});
  const [payrollEntries, setPayrollEntries] = useState([]);
  const [defaultPayrollEntries, setDefaultPayrollEntries] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingButton, setLoadingButton] = useState(false);
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const { id } = useParams();

  const columns = [
    {
      title: "#",
      dataIndex: "index",
      key: "index",
      width: 50,
      render: (id, record, index) => {
        return (index += 1);
      },
    },
    {
      title: t("text_title"),
      dataIndex: "name",
      key: "name",
      width: 250,
    },
    {
      title: t("text_amount"),
      key: "amount",
      dataIndex: "amount",
      width: 120,
      render: (amount, record, index) => {

        form.setFieldsValue({ [`amount[${index}]`]: Math.abs(amount) });
        return (
          <NumberInput
            style={{ margin: 0 }}
            name={`amount[${index}]`}
            placeholder={t("text_amount")}
            errorMessage={t("text_please_enter_amout")}
            onChange={(value) => onChangeAmount(record.id, value)}
            initialValue={amount ? amount.toFixed(2) : 0}
            precision={2}
            isAutoSelect={true}
            required={true}
          />
        );
      },
    }
  ];

  useEffect(() => {

    if (Util.getInstance().hasPermission("edit", "payroll")) {
      setLoading(true);
      getOne(id)
        .then((response) => {
          const data = response.data;
          if (response) {
            form.setFieldsValue({
              dates: [moment(data.periodFrom), moment(data.periodTo)],
              remark: data.remark,
            });
          }

          if (response.data.payrollEntries !== undefined) {
            const newPayrollEntries = data.payrollEntries.map((value) => ({
              id: value.id,
              name: value.payrollItem.title,
              amount: value.amount,
              type: value.type,
              payrollItemId: parseInt(value.payrollItemId),
            }));
            setPayrollEntries(newPayrollEntries);
            setDefaultPayrollEntries([...newPayrollEntries]);
          }
          setFormData(response.data);
        }).catch(error => {
          if (error.response && error.response.status === 403) {
            localStorage.removeItem("ACCESS_TOKEN");
            navigate("/signin");
          }
        })
        .finally(() => {
          setLoading(false);
        });

    }
    // eslint-disable-next-line
  }, []);

  const onFinish = (values) => {
    if (id) {
      let newValue = {};
      if (defaultPayrollEntries.length > 0) {
        newValue["payrollEntries"] = defaultPayrollEntries;
      } else {
        newValue["payrollEntries"] = payrollEntries;
      }

      setLoadingButton(true);
      updateRecordById(id, newValue)
        .then(() => {
          goBack();
        })
        .finally(() => setLoadingButton(false));
    }
  };

  const goBack = () => {
    navigate("/payrolls");
  };

  const handleCancel = () => {
    goBack();
  };

  const onChangeAmount = (id, value) => {
    const foundAmount = payrollEntries.find((value) => value.id === id);
    if (foundAmount["type"] === 2) {
      foundAmount.amount = -Math.abs(value);
    } else {
      foundAmount.amount = value
    }
    setPayrollEntries([...payrollEntries]);
  };

  return (
    <>
      {
        Util.getInstance().hasPermission("edit", "payroll")
          ?
          <Form onFinish={onFinish} form={form}>
            <div className="btn-navigation">
              <Row>
                <Col span={12}>
                  <div className="pull-left">
                    <Button onClick={handleCancel}>
                      <ArrowLeftOutlined />
                      {t("text_back")}
                    </Button>
                    <span className="title">{t("text_payroll")} {t("text_employee_id")}: {formData?.employee?.code}</span>
                  </div>
                </Col>
                <Col span={12}>
                  <div className="pull-right">
                    <Button htmlType="submit" loading={loadingButton}>
                      {t("text_save")}
                    </Button>
                  </div>
                </Col>
              </Row>
            </div>
            <div
              className="data-table"
              id="data-table"
              style={{
                paddingLeft: 25,
                paddingRight: 25,
                paddingTop: 20
              }}
            >
              <Table
                rowKey={(record) => `${record.payrollItemId}`}
                dataSource={payrollEntries}
                columns={columns}
                loading={loading}
                pagination={false}
              />
            </div>
          </Form>
          :
          <Result
            status="403"
            title="403"
            subTitle={t("text_sorry_you_are_not_authorized_to_access_this_page")}
          />

      }
    </>
  );
};

export default UpdatePayroll;
